import { api } from '@/api';
import router from '@/router';
import { AxiosError } from 'axios';
import { getStoreAccessors } from 'typesafe-vuex';
import { ActionContext } from 'vuex';
import { State } from '../state';
import {
    commitSetSubscriptionPackages, commitSetSubscriptionPeriods, commitSetSubscriptionsInfo,
} from './mutations';
import { SubscriptionState } from './state';
import { dispatchCheckApiError } from '../main/actions';

type MainContext = ActionContext<SubscriptionState, State>;

export const actions = {
     async actionGetSubscriptionPeriods(context: MainContext) {
         try {
             const response = await api.getSubscriptionPeriods(context.rootState.main.token);
             if (response.data) {
                 commitSetSubscriptionPeriods(context, response.data);
             }
         } catch (error) {
             await dispatchCheckApiError(context, error);
         }
     },
     async actionGetSubscriptionPackages(context: MainContext, payload: any) {
         try {
             const response = await api.getSubscriptionPackages(context.rootState.main.token, payload);
             if (response.data) {
                 commitSetSubscriptionPackages(context, response.data);
             }
         } catch (error) {
             await dispatchCheckApiError(context, error);
         }
     },
     async actionGetPackagePaymentUrl(context: MainContext, payload: { package: number }) {
         try {
            const response = await api.getPackagePaymentUrl(context.rootState.main.token, payload);
            return response.data;
         } catch (error) {
             await dispatchCheckApiError(context, error);
             return null;
         }
     },
     async actionGetDonationPaymentUrl(context: MainContext, payload: { amount: number, auto_pay: boolean }) {
         try {
             const response = await api.getDonationPaymentUrl(context.rootState.main.token, payload);
             if (response.status === 200) {
                 return response.data;
             }
         } catch (error) {
             await dispatchCheckApiError(context, error);
             return '';
         }
     },
     async actionGetSubscriptionsInfo(context: MainContext) {
         try {
             const response = await api.getSubscriptionInfo(context.rootState.main.token);
             if (response.data) {
                 commitSetSubscriptionsInfo(context, response.data);
             }
         } catch (error) {
             await dispatchCheckApiError(context, error);
         }
     },
     async actionToggleSubscriptionsAutoPay(context: MainContext, payload: { action: string }) {
         try {
             const response = await api.getSubscriptionToggleAutoPay(context.rootState.main.token, payload);
             await dispatchGetSubscriptionsInfo(context);
         } catch (error) {
             await dispatchCheckApiError(context, error);
         }
     },
};

const { dispatch } = getStoreAccessors<SubscriptionState | any, State>('');

export const dispatchGetSubscriptionPeriods = dispatch(actions.actionGetSubscriptionPeriods);
export const dispatchGetSubscriptionPackages = dispatch(actions.actionGetSubscriptionPackages);
export const dispatchGetPackagePaymentUrl = dispatch(actions.actionGetPackagePaymentUrl);
export const dispatchGetDonationPaymentUrl = dispatch(actions.actionGetDonationPaymentUrl);
export const dispatchGetSubscriptionsInfo = dispatch(actions.actionGetSubscriptionsInfo);
export const dispatchToggleSubscriptionsAutoPay = dispatch(actions.actionToggleSubscriptionsAutoPay);
